<template>
  <div class="m-4">
    <div class="card w-full">
      <Tabs
        :value="route.path"
        class="w-full"
      >
        <TabList class="w-full">
          <Tab
            v-for="tab in items"
            :key="tab.label"
            :value="tab.route"
          >
            <router-link
              v-slot="{ href, navigate }"
              :to="tab.route"
              custom
            >
              <a
                v-ripple
                :href="href"
                class="flex items-center gap-2 text-inherit"
                @click="navigate"
              >
                <i :class="tab.icon" />
                <span>{{ tab.label }}</span>
              </a>
            </router-link>
          </Tab>
        </TabList>
      </Tabs>

      <!-- Content slot with full width -->
      <div class="mt-4 w-full">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// Define the tab items with icons
const items = ref([
    {
        route: '/finance/overview',
        label: 'Overview',
        icon: 'pi pi-chart-bar'  // Chart icon for overview
    },
    {
        route: '/finance/purchase-orders',
        label: 'Purchase Orders',
        icon: 'pi pi-file'  // File icon for purchase orders
    },
    {
        route: '/finance/invoices',
        label: 'Invoices',
        icon: 'pi pi-money-bill'  // Money bill icon for invoices
    },
    {
        route: '/finance/quotes',
        label: 'Quotes',
        icon: 'pi pi-calculator'  // Calculator icon for quotes
    }
]);
</script>

<style scoped>
/* Add any custom styling if needed */
.text-inherit {
    color: inherit;
    text-decoration: none;
}

.items-center {
    align-items: center;
}

.flex {
    display: flex;
}

.gap-2 {
    gap: 0.5rem;
}

/* Ensure card takes full width */
.card {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

/* Ensure tab content can be full width */
:deep(.p-tabview-panels) {
    width: 100%;
}
</style>